import React, { ReactElement, useMemo } from "react";
import { Column } from "../../../../components/BaseTable";
import Table from "../../../../components/Table";
import { DubbeleLastenDetails } from "../../../../../../.generated/rapportage/rapportagetypes";

export const DubbeleLastenDetailsTable = ({
  huidigeSituatie,
  nieuweSituatie,
}: {
  huidigeSituatie: DubbeleLastenDetails | null;
  nieuweSituatie: DubbeleLastenDetails | null;
}): ReactElement => {
  const columns = useMemo((): Column[] => {
    const result: Column[] = [
      {
        header: "Hypotheek",
        accessor: "onderdeel",
      },
      {
        header: "Ingangsdatum",
        accessor: "ingangsdatum",
        dataType: "date",
      },
      {
        header: "Bedrag",
        accessor: "bedrag",
        dataType: "currency",
      },
      {
        header: "Rente leningdeel 1",
        accessor: "renteLeningdeel1",
        dataType: "percentage",
      },
      {
        header: "Bruto maandlast",
        accessor: "brutoMaandlast",
        dataType: "currency",
      },
      {
        header: "Netto maandlast",
        accessor: "nettoMaandlast",
        dataType: "currency",
      },
    ];
    if (
      huidigeSituatie?.overbruggingskredietBrutoMaandlast ||
      huidigeSituatie?.overbruggingskredietNettoMaandlast
    ) {
      result.push({
        header: " ",
        accessor: () => " ",
      });
    }
    result.push({
      header: "Overbruggingskrediet bruto maandlast",
      accessor: "overbruggingskredietBrutoMaandlast",
      dataType: "currency",
    });
    result.push({
      header: "Overbruggingskrediet netto maandlast",
      accessor: "overbruggingskredietNettoMaandlast",
      dataType: "currency",
    });

    const renteLeningdelenCount = Math.max(
      nieuweSituatie?.renteLeningdelen?.length ?? 0,
      huidigeSituatie?.renteLeningdelen?.length ?? 0
    );

    for (let i = 0; i < renteLeningdelenCount; i++) {
      result.splice(3 + i, 0, {
        header: `Rente leningdeel ${i + 1}`,
        accessor: (data: DubbeleLastenDetails) => {
          return data.renteLeningdelen ? data.renteLeningdelen[i] ?? "" : "";
        },
        dataType: "percentage",
      });
    }
    return result;
  }, [nieuweSituatie, huidigeSituatie]);

  const dataTransformed: (DubbeleLastenDetails & { onderdeel: string })[] = [];
  if (huidigeSituatie) {
    dataTransformed.push({
      ...huidigeSituatie,
      onderdeel: "Huidige situatie",
    });
  }
  if (nieuweSituatie) {
    dataTransformed.push({
      ...nieuweSituatie,
      onderdeel: "Nieuwe situatie",
    });
  }

  return (
    <>
      {dataTransformed?.length > 0 && (
        <Table
          data={dataTransformed}
          columns={columns}
          rotate={true}
          id="dubbele-woonlasten-table"
          regularStyles
        />
      )}
    </>
  );
};
